import PDPPricingManager from './PDPPricingManager';

document.addEventListener( 'DOMContentLoaded', function() {
	new PDPPricingManager();
} );
